import { Value } from 'sass';
import Database  from './model'
const {Get,Post,Image} = Database();

export const RegisterUser = async(FormData) => {
    let response = await Post({url:'auth/register', bodyData:FormData});
   return response;
}

export const LoginUser = async(FormData) => {
    let response =await Post({url:'auth/login', bodyData:FormData});
    return response;
}
    
export const LogOutUser = async(FormData) => {
    let response =await Post({url:'auth/logout', bodyData:FormData});
    return response;
}

export const UserExist = async (email, value, id) => {
    // Base URL
    console.log("id", id)
    let url = `auth/isexist?email=${email}&value=${value}`;
  
    // Append id parameter if provided
    if (id) {
      url += `&id=${id}`;
    }
  
    // Perform the GET request
    let response = await Get({ url });
  
    return response;
  }
export const ForgotPasswordAPI = async(email) => {
    let response = await Post({url:'auth/forgot-password', bodyData: email});
    return response;
}

export const ForgotPasswordValidLinkAPI = async(id, token) => {
    let response = await Post({url:'auth/forgot-password-valid-link', bodyData: {id: id, token : token}});
    return response;
}

export const otpVerification = async(otp) => {
    let response = await Post({url:'auth/otp-verification', bodyData: otp});
    return response;

}

export const NewPasswordAPI = async(password) => {
    let response = await Post({url:'auth/new-password', bodyData: password});
    return response;
}

export const Authenticated = async(token) => {
    let response = await Post({url:'auth/authenticated', bodyData: token});
    return response;
}

export const Profile = async() => {
    let response = await Get({url: 'auth/profile'})
    return response;
}

export const UpdateProfile = async(FormData) => {
    let response = await Image({url:'auth/update-profile', bodyData: FormData})
    return response;
}

export const GetTeams = async(city) => {
    const url = city 
    ? `auth/teams/get?city=${city}`
    : `auth/teams/get`;
    let response = await Get({ url })

    return response;
}
